module.exports = __webpack_public_path__ + "static/img/quanyi.22fd2f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/mem/quanyi.png
// module id = al0f
// module chunks = 1